import { render } from "./ActivityDetail.vue?vue&type=template&id=1c425d20&scoped=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"

import "./ActivityDetail.vue?vue&type=style&index=0&id=1c425d20&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c425d20"]])

export default __exports__